<app-stages [stages]="stages"
            currentStage="Szczegółowe informacje dotyczące treści pisma">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <fieldset>
      <legend>
        Działki
      </legend>
      <app-parcels-crud
        [planNameControl]="planNameControl()"
        [isEntireParcelCoveredByPlanControl]="true"
        formControlName="parcels"
        [detailedInformationControls]="canAddDetailedInformationControls()">
      </app-parcels-crud>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
